import React from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import I18n from 'utils/I18n';
import styles from '../styles.scss';

import { mapProps } from '../../../../props/feed-prop-types';

// "Try this route" button on maps
const handleRouteButtonClick = (activityId) => {
  window.location.href = `/activities/${activityId}/route`;
};

const tag = (label, className) => (
  <div
    data-testid="tag"
    key={label}
    className={`${styles.activityMapTag} ${className || ''}`}
  >
    {I18n.t(label)}
  </div>
);

const buildActivityMapTags = ({ isVirtual, isCommute, workoutType }) => {
  const tags = [];
  if (isVirtual) {
    tags.push(tag('templates.feed.activity.tag.virtual'));
  }
  if (isCommute) {
    tags.push(tag('templates.feed.activity.tag.commute'));
  }
  if (workoutType) {
    const className = workoutType === 'race' ? styles.tagRace : '';
    tags.push(tag(`templates.feed.activity.tag.${workoutType}`, className));
  }
  return tags;
};

const Map = ({
  activityMap,
  isRoutable,
  activityId,
  entryTypeClassName,
  isVirtual,
  isCommute,
  workoutType
}) => {
  const elements = [];
  // "Try this Route" button
  if (isRoutable) {
    elements.push(
      <div
        data-testid="try-route"
        key="try-route"
        className={styles.activityMapCreateRoute}
      >
        <Button
          type="button"
          variant="default"
          className={`${styles.btn} ${styles.btnSm} ${styles.textBold}`}
          onClick={() => handleRouteButtonClick(activityId)}
        >
          {I18n.t('templates.feed.activity.try_route')}
        </Button>
      </div>
    );
  }
  // Map image
  elements.push(
    <a key="map" href={`/activities/${activityId}`}>
      <div className={styles.activityMapTags}>
        {buildActivityMapTags({ isVirtual, isCommute, workoutType })}
      </div>
      <img
        data-testid="map"
        src={activityMap.url}
        srcSet={activityMap.url}
        alt={activityMap.alt}
        className={entryTypeClassName}
      />
    </a>
  );
  return (
    <div className={`${entryTypeClassName} ${styles.entryImage}`}>
      <div className={styles.entryImageWrapper}>{elements}</div>
    </div>
  );
};

Map.propTypes = {
  activityId: PropTypes.string.isRequired,
  isRoutable: PropTypes.bool.isRequired,
  activityMap: mapProps.isRequired,
  entryTypeClassName: PropTypes.oneOf([
    styles.activityMap,
    styles.groupActivityMap
  ]).isRequired,
  isVirtual: PropTypes.bool,
  isCommute: PropTypes.bool,
  workoutType: PropTypes.oneOf(['race', 'long_run', 'workout'])
};

Map.defaultProps = {
  workoutType: null,
  isVirtual: false,
  isCommute: false
};

export default Map;
